import { queryOptions, useQuery } from '@tanstack/react-query';
import { groupBy } from 'lodash-es';
import type { RespondedWith } from '@/models/response';
import type { Sticker as StickerType } from '@/models/sticker';
import { fetcher } from '@/utils/fetcher';
import type { StickerProps } from '../sticker/sticker';
import type { SymbolCategory } from '../symbol.type';

export const stickersQueryOptions = queryOptions({
  queryKey: ['/GetEmote'],
  queryFn: ({ signal }) =>
    fetcher<RespondedWith<StickerType[]>>(
      '/GetEmote',
      { cid: 0 },
      { requestContentType: 'query', signal, validResponseCodes: [0] },
    ).then((response) =>
      Object.entries(groupBy<StickerType>(response.Data ?? [], (item) => `sticker_category_${item.ClassID}`)).map(
        ([slug, symbols]): SymbolCategory<StickerProps> => ({
          name: slug,
          slug,
          symbols:
            symbols?.map((item) => ({
              id: item.ID,
              url: item.Url,
            })) ?? [],
        }),
      ),
    ),
  placeholderData: [],
  staleTime: 30 * 24 * 60 * 60 * 1000,
  gcTime: 365 * 24 * 60 * 60 * 1000,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
});

export default function useStickers() {
  const query = useQuery(stickersQueryOptions);

  return {
    stickers: query.data ?? [],
    ...query,
  };
}
